import { FC } from 'react';

import { Tiers } from './Tiers';
import { SalesRep } from './SalesRep';
import { Location } from './Location';
import { OpportunityType } from './OpportunityType';
import { DealStage } from './DealStage';
import { DealStatus } from './DealStatus';
import { ClosedDeals } from './ClosedDeals';
import { DisplayType } from './DisplayType';
import { ApplyingFor } from './ApplyingFor';
import { SalesManager } from './SalesManager';
import { FinanceManager } from './FinanceManager';
import { ColumnsManager } from './ColumnsManager';
import { DealPaymentType } from './DealPaymentType';
import { CreateDateRange } from './CreateDateRange';

import { VOFilterCardProps, VOFilterType } from '../../types';

export const componentCardToTypeMapper: Record<VOFilterType, { label: string; component: FC<VOFilterCardProps> }> = {
  [VOFilterType.TIERS]: { label: 'Tiers', component: Tiers },
  [VOFilterType.STAGE]: { label: 'Deal Stage', component: DealStage },
  [VOFilterType.LOCATION]: { label: 'Location', component: Location },
  [VOFilterType.DISPLAY]: { label: 'Display', component: DisplayType },
  [VOFilterType.SALES_REP]: { label: 'Sales Rep', component: SalesRep },
  [VOFilterType.OPPORTUNITY_TYPE]: { label: 'Opportunity Type', component: OpportunityType },
  [VOFilterType.STATUS]: { label: 'Deal Status', component: DealStatus },
  [VOFilterType.APPLYING_FOR]: { label: 'Applying for', component: ApplyingFor },
  [VOFilterType.SALES_MANAGER]: { label: 'Sales Manager', component: SalesManager },
  [VOFilterType.PAYMENT_TYPE]: { label: 'Payment Type', component: DealPaymentType },
  [VOFilterType.CREATE_DATE_RANGE]: { label: 'Created', component: CreateDateRange },
  [VOFilterType.SET_OF_DATA]: { label: 'Columns Selector', component: ColumnsManager },
  [VOFilterType.CLOSED_DEALS]: { label: 'Include closed deals', component: ClosedDeals },
  [VOFilterType.FINANCE_MANAGER]: { label: 'Finance Manager', component: FinanceManager },
};
